"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    STORAGE_ITEM_NAME: function() {
        return STORAGE_ITEM_NAME;
    },
    getFormattedRefererParams: function() {
        return getFormattedRefererParams;
    },
    getRefererParams: function() {
        return getRefererParams;
    },
    getRefererParamsToEvent: function() {
        return getRefererParamsToEvent;
    },
    getRefererParamsToPageView: function() {
        return getRefererParamsToPageView;
    },
    setRefererParamsToPageView: function() {
        return setRefererParamsToPageView;
    }
});
var _define_property = require("@swc/helpers/_/_define_property");
var _object_spread = require("@swc/helpers/_/_object_spread");
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var _type_of = require("@swc/helpers/_/_type_of");
var STORAGE_ITEM_NAME = "tracking_extended_params";
var getFormattedRefererParams = function(params, key) {
    var typeofParams = typeof params === "undefined" ? "undefined" : _type_of._(params);
    if (typeofParams === "undefined" || typeofParams === "string" && typeofParams.length === 0 || params === null) {
        return {};
    }
    var currentParams = {};
    if (Array.isArray(params) || [
        "string",
        "boolean",
        "number"
    ].includes(typeofParams)) {
        currentParams = _define_property._({}, key, params);
    }
    if (!Array.isArray(params) && (typeof params === "undefined" ? "undefined" : _type_of._(params)) === "object") {
        currentParams = params;
    }
    return {
        referrer_params: currentParams,
        key: key
    };
};
var setRefererParamsToPageView = function(data) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof window === "undefined") {
        return;
    }
    var keyName = options.keyName;
    var dataFiltered = data;
    var propertyName = keyName || STORAGE_ITEM_NAME;
    if (dataFiltered === null || typeof dataFiltered === "undefined") {
        throw new Error("setExtendedParamsToPageView : data is null or undefined");
    }
    if (JSON.stringify(dataFiltered) === "{}" || JSON.stringify(dataFiltered) === "[]" || typeof dataFiltered === "string" && dataFiltered.length === 0) {
        throw new Error("setExtendedParamsToPageView : data is empty");
    }
    if (!Array.isArray(dataFiltered) && (typeof dataFiltered === "undefined" ? "undefined" : _type_of._(dataFiltered)) === "object") {
        dataFiltered = Object.fromEntries(Object.entries(dataFiltered).filter(function(param) {
            var _param = _sliced_to_array._(param, 2), value = _param[1];
            return typeof value !== "undefined";
        }));
    }
    var currentDataStorage = JSON.parse(window.localStorage.getItem(STORAGE_ITEM_NAME) || "{}");
    window.localStorage.setItem(STORAGE_ITEM_NAME, JSON.stringify(_object_spread._({}, currentDataStorage, _define_property._({}, propertyName, dataFiltered))));
};
var getRefererParams = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (typeof window === "undefined") {
        return {};
    }
    var _options_keyname = options.keyname, keyname = _options_keyname === void 0 ? null : _options_keyname, _options_storage = options.storage, storage = _options_storage === void 0 ? null : _options_storage, _options_removeKey = options.removeKey, removeKey = _options_removeKey === void 0 ? true : _options_removeKey;
    if (!storage || typeof storage.getItem !== "function") {
        return {};
    }
    var key = keyname || window.location.pathname;
    var extendedParams = JSON.parse(storage.getItem(STORAGE_ITEM_NAME) || "{}");
    var params = extendedParams[key] || null;
    if (removeKey === true && params) {
        delete extendedParams[key];
        var updatedParams = JSON.stringify(extendedParams);
        if (updatedParams === "{}" || !updatedParams) {
            storage.removeItem(STORAGE_ITEM_NAME);
        } else {
            storage.setItem(STORAGE_ITEM_NAME, JSON.stringify(extendedParams));
        }
    }
    return getFormattedRefererParams(params, key);
};
var getRefererParamsToPageView = function(keyname) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        removeKey: true
    };
    if (typeof window === "undefined") {
        return {};
    }
    var referrerParams = getRefererParams({
        keyname: keyname,
        storage: window.localStorage,
        removeKey: options.removeKey
    });
    // Use sessionStorage because a browsing session is only valid for the current browsing context,
    // i.e. opening a page in a new tab or window will initiate a new browsing session
    // This storage should be use only temporary for track event in the current page
    window.sessionStorage.removeItem(STORAGE_ITEM_NAME);
    if ("referrer_params" in referrerParams && typeof referrerParams.key === "string") {
        window.sessionStorage.setItem(STORAGE_ITEM_NAME, JSON.stringify(_define_property._({}, referrerParams.key, referrerParams.referrer_params)));
    }
    return referrerParams;
};
var getRefererParamsToEvent = function(keyname, options) {
    if (!options) {
        // eslint-disable-next-line no-param-reassign
        options = {
            removeKey: false
        };
    }
    var referrerParams = getRefererParams({
        keyname: keyname,
        storage: window.sessionStorage,
        removeKey: options.removeKey
    });
    return referrerParams;
};

//# sourceMappingURL=refererParams.js.map